import axios from "axios";
import { BASE_URL } from "../constants";
import { firebaseSignOut, getFirebaseIdToken } from "../firebase";

const axiosInstance = axios.create({
  baseURL: BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

axiosInstance.interceptors.request.use(
  async (config) => {
    const token = await getFirebaseIdToken();
    if (token) {
      //@ts-ignore
      config.headers = {
        ...config.headers,
        authorization: `Bearer ${token}`,
      };
    }
    return config;
  },
  (error) => Promise.reject(error)
);

axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const status = error?.response?.status;
    const originalRequest = error?.config;

    if (status === 401 && originalRequest && !originalRequest._retry) {
      originalRequest._retry = true;
      const freshToken = await getFirebaseIdToken(true);
      if (freshToken) {
        originalRequest.headers = {
          ...(originalRequest.headers || {}),
          authorization: `Bearer ${freshToken}`,
        };
        return axiosInstance(originalRequest);
      }
      await firebaseSignOut().catch(() => {});
      window.location.replace("/signIn");
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;
